var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { borderRadius as borderRadiusTokens, colors as colorTokens, depth as depthTokens, space as spaceTokens, type as typeTokens, } from '@workday/canvas-kit-react/tokens';
var getColor = function (value) {
    return colorTokens[value] || value;
};
var getDepth = function (value) {
    return depthTokens[value];
};
var getShape = function (value) {
    return borderRadiusTokens[value] || value;
};
var getSpace = function (value) {
    return spaceTokens[value] || value;
};
var getFont = function (value) {
    return typeTokens.properties.fontFamilies[value] || value;
};
var getFontSize = function (value) {
    return typeTokens.properties.fontSizes[value] || value;
};
var getFontWeight = function (value) {
    return typeTokens.properties.fontWeights[value] || value;
};
export function buildStyleFns(styleFnConfigs) {
    return styleFnConfigs.reduce(function (styleFns, styleFnConfig) {
        var _a;
        if (styleFns === void 0) { styleFns = {}; }
        var styleFn = function (value) {
            return styleFnConfig.properties.reduce(function (styles, property) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (styles === void 0) { styles = {}; }
                if (styleFnConfig.system === 'color') {
                    return __assign(__assign({}, styles), (_a = {}, _a[property] = getColor(value), _a));
                }
                if (styleFnConfig.system === 'depth') {
                    // Depth tokens return the style property (box-shadow) and the value
                    var depthStyle = getDepth(value);
                    return __assign(__assign({}, styles), depthStyle);
                }
                if (styleFnConfig.system === 'font') {
                    return __assign(__assign({}, styles), (_b = {}, _b[property] = getFont(value), _b));
                }
                if (styleFnConfig.system === 'fontSize') {
                    return __assign(__assign({}, styles), (_c = {}, _c[property] = getFontSize(value), _c));
                }
                if (styleFnConfig.system === 'fontWeight') {
                    return __assign(__assign({}, styles), (_d = {}, _d[property] = getFontWeight(value), _d));
                }
                if (styleFnConfig.system === 'shape') {
                    return __assign(__assign({}, styles), (_e = {}, _e[property] = getShape(value), _e));
                }
                if (styleFnConfig.system === 'space') {
                    return __assign(__assign({}, styles), (_f = {}, _f[property] = getSpace(value), _f));
                }
                return __assign(__assign({}, styles), (_g = {}, _g[property] = value, _g));
            }, {});
        };
        return __assign(__assign({}, styleFns), (_a = {}, _a[styleFnConfig.name] = styleFn, _a));
    }, {});
}
export function buildStylePropFn(styleFns) {
    return function (props) {
        var styles = {};
        for (var key in props) {
            if (key in props && key in styleFns) {
                var styleFn = styleFns[key];
                var value = props[key];
                var style = styleFn(value);
                styles = __assign(__assign({}, styles), style);
                continue;
            }
        }
        return styles;
    };
}
